var PackagesSlider = (function (window) {


  var $sliders;

  function isEditingMode() {
    return $sliders
    && $sliders.parent('.acr-packages-slider')
    && $sliders.parent('.acr-packages-slider').hasClass('editing-mode');
  }

  function setEditingModeScreenWidth() {
    var width = 0;

    var packages = $('.acr-packages-slick .package');

    packages.each(function () {
      width += this.offsetWidth;
    });

    $('.acr-packages-slick').width(width);
  }

  function getNumberOfDots(el, slick) {
    var slidesToShow = slick.options.slidesToShow;

    if (slidesToShow < slick.$slides.length) {
      return (slick.$slides.length - slidesToShow) + 1;
    }

    return 0;
  }

  function setSlick() {
    $sliders = $('.acr-packages-slick');

    if (isEditingMode()) {
      return;
    }

    if ($sliders) {
      $sliders.slick({
        infinite: false,
        dots: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: '<button type="button" data-role="none"'
            + ' class="slick-prev acr-icon-arrow-large-left acr-f4 acr-mid-grey"'
            + ' aria-label="Previous" tabindex="0" role="button"></button>',
        nextArrow: '<button type="button" data-role="none"'
            + ' class="slick-next acr-icon-arrow-large-right acr-f4 acr-mid-grey"'
            + ' aria-label="Next" tabindex="0" role="button"></button>',
        useTransform: true,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: true,
          },
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }],
      });
      $sliders.on('afterChange', function (event, slick, currentSlide) {
        var $this = $(this);

        if (currentSlide >= getNumberOfDots(this, slick)) {
          setTimeout(function () {
            $this.slick('slickGoTo', getNumberOfDots(this, slick) - 1, true);
          }, 10);
        }
      });

      $sliders.on('setPosition', function (event, slick) {
        var i;

        var dots = slick.$dots ? slick.$dots.find('li') : [];

        var numberOfDots = getNumberOfDots(this, slick);

        if (dots.length > numberOfDots) {
          for (i = numberOfDots; i < dots.length; i++) {
            dots[i].remove();
          }
        }
      });
    }
  }

  $(window).on('resize', $.throttle(250, function () {
    setTimeout(function () {
      if (isEditingMode()) {
        setEditingModeScreenWidth();
      }
    }, 200);

    if (window.innerWidth >= Constants.breakpoints.md) {
      if ($sliders && $sliders.hasClass('slick-initialized')) {
        $sliders.slick('unslick');
      }
    } else if ($sliders && !$sliders.hasClass('slick-initialized')) {
      setSlick();
    }
  }));

  function init() {
    $('.acr-packages').addClass('acr-total-packages-'
      + $('.acr-packages-slick .package').length);

    setSlick();
    if (window.innerWidth >= Constants.breakpoints.md) {
      $sliders.slick('unslick');
    }
  }

  return {
    init: init,
  };
}(window));
